import React from "react"
import {Box, Breadcrumbs, Container, Stack, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import ServiceItemPlaceholder from "./ServiceItemPlaceholder";
import {useServiceList} from "./hook/useServiceList";
import ServiceItem from "./ServiceItem";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

const ServiceList = () => {

    const navigate = useNavigate()

    const {isLoading, services} = useServiceList();

    const {mode} = useDarkMode();

    return <Container maxWidth="lg" style={{marginTop: '29px'}} id="service-list">
        <Breadcrumbs separator="›" aria-label="breadcrumb">
            {[
                <Typography className={'text-gradient2 breadcrumbs'} variant={'body2'} onClick={() => navigate('/')} >
                    Accueil
                </Typography>,
                <Typography className={'text-gradient2 breadcrumbs'} variant={'body2'} onClick={() => navigate('/products')} >
                    Service
                </Typography>,
                <Typography className={'text-gradient2 breadcrumbs'} variant={'body2'}>
                    Tout les services
                </Typography>,
            ]}
        </Breadcrumbs>
        <Typography variant='h2' marginTop={5} sx={{marginBottom: '40px', color: mode.settings.textColor6}}>
            MES SERVICES ET CONSEILS
        </Typography>
        <Box>
            <Stack
                direction="row"
                flexWrap="wrap"
                gap="20px"
                marginBottom="20px"
            >
                {
                    isLoading && Array(6).fill("").map( () => <ServiceItemPlaceholder/> )
                }

                {
                    !isLoading && services.map( (service, index) => <ServiceItem {...service} key={index}/> )
                }
            </Stack>
        </Box>
    </Container>
}

export default ServiceList
